module.exports = __webpack_public_path__ + "img/do.edd41e2e.svg";